import { compose, prop, nthArg, path, curry, defaultTo, propOr } from 'ramda';

const pickState = nthArg(0);
const pickPayload = compose(propOr(null, 'payload'), nthArg(1));
const propFromPayload = x => compose(prop(x), pickPayload);
const pathFromPayload = x => compose(path(x), pickPayload);
const pathOrFromPayload = curry((a, b) =>
  compose(defaultTo(a), pathFromPayload(b)),
);

export {
  pickState,
  pickPayload,
  propFromPayload,
  pathFromPayload,
  pathOrFromPayload,
};
